import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import { convertMinutesToHours } from "../../../utils";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .close-icon-btn": {
    position: "absolute",
    top: "5px",
    right: "5px",
  },
}));

const DurationDialog = forwardRef(({ showCloseBtn }, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      console.log(params, "paramsparamsparamsparamsparams");
      setDialogData(params);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  console.log(dialogData, "dialogDatadialogDatadialogData");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton className="close-icon-btn" onClick={handleClose}>
        <CloseIcon />
      </IconButton>

      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {t("duration")}
      </DialogTitle>
      <DialogContent dividers>
        <Box border={"1px solid grey"} borderRadius={1} overflow={"hidden"}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t("service")}</TableCell>
                <TableCell align="center">{t("duration")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dialogData?.data?.serviceSubCategoryId?.type === "area" && (
                <TableRow>
                  <TableCell>{t("perAreaDuration")}</TableCell>
                  <TableCell align="center">
                    {convertMinutesToHours(
                      dialogData?.data?.serviceSubCategoryId?.duration?.area
                    ) || "0 min"}
                  </TableCell>
                </TableRow>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type === "fixed" && (
                <TableRow>
                  <TableCell>{t("serviceDuration")}</TableCell>
                  <TableCell align="center">
                    {convertMinutesToHours(
                      dialogData?.data?.serviceSubCategoryId?.duration?.fixed
                    ) || "0 min"}
                  </TableCell>
                </TableRow>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type === "room+area" && (
                <>
                  <TableRow>
                    <TableCell>{t("perAreaDuration")}</TableCell>
                    <TableCell align="center">
                      {convertMinutesToHours(
                        dialogData?.data?.serviceSubCategoryId?.duration?.area
                      ) || "0 min"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("perRoomDuration")}</TableCell>
                    <TableCell align="center">
                      {convertMinutesToHours(
                        dialogData?.data?.serviceSubCategoryId?.duration?.room
                      ) || "0 min"}
                    </TableCell>
                  </TableRow>
                </>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type ===
                "interior+exterior" && (
                <>
                  <TableRow>
                    <TableCell>{t("interiorServiceDuration")}</TableCell>
                    <TableCell align="center">
                      {convertMinutesToHours(
                        dialogData?.data?.serviceSubCategoryId?.duration
                          ?.interior
                      ) || "0 min"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("exteriorServiceDuration")}</TableCell>
                    <TableCell align="center">
                      {convertMinutesToHours(
                        dialogData?.data?.serviceSubCategoryId?.duration
                          ?.exterior
                      ) || "0 min"}
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default DurationDialog;
